import React from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CompanyAccess } from "@me-team/host/main/graphql/types";
import { useRoleAccess } from "@me-team/host/src/utils/useRoleAccess";

type DropdownServicesPropsType = {
    currentCompanyId: string | number;
    serviceId: string | number;
    branchId: string | number;
};

const DropdownServices: React.FC<DropdownServicesPropsType> = ({ currentCompanyId, serviceId, branchId }) => {
    const { t } = useTranslation();
    const canEditService = useRoleAccess(CompanyAccess.ServiceAndOnlineBookingEdit);

    return (
        <Dropdown className="dropdown-action" drop={"down-centered"}>
            <Dropdown.Toggle variant="outline-orange" id="actionsDropdown" className="w-100 px-3">
                <div className="d-flex justify-content-between">
                    <Link
                        to={`/services/service/${currentCompanyId}/service-list/${branchId}`}
                        className="text-orange text-decoration-none text-truncate me-2"
                    >
                        {t("All services")}
                    </Link>
                    <i className={`bi bi-chevron-down transition-icon`}></i>
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {canEditService && (
                    <Dropdown.Item
                        as={Link}
                        to={`/services/service/${currentCompanyId}/service-list/${serviceId}/edit/${branchId}`}
                        className="py-2"
                    >
                        {t("To service")}
                    </Dropdown.Item>
                )}
                <Dropdown.Item
                    as={Link}
                    to={`/services/service/${currentCompanyId}/service-list/${branchId}`}
                    className="py-2"
                >
                    {t("All services")}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default DropdownServices;
